import { render, staticRenderFns } from "./PresupuestosInternosData.vue?vue&type=template&id=60f6b9d3&"
import script from "./PresupuestosInternosData.vue?vue&type=script&lang=js&"
export * from "./PresupuestosInternosData.vue?vue&type=script&lang=js&"
import style0 from "./PresupuestosInternosData.vue?vue&type=style&index=0&id=60f6b9d3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports